import { Box } from "@mui/material";
import "./card-wrapper.scss";
import React from "react";

interface CardWrapperPropsType {
  children: React.ReactNode;
}

const CardWrapper = ({ children, ...rest }: CardWrapperPropsType) => {
  return (
    <Box className="card-wrapper" {...rest}>
      {children}
    </Box>
  );
};

export { CardWrapper };
export default CardWrapper;
